/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentbalances": {
        "nested": {
          "ActivityType": {
            "values": {
              "UNKNOWN_PAYOUT_ENTRY_TYPE_DO_NOT_USE": 0,
              "ADJUSTMENT": 1,
              "APP_FEE_REFUND": 2,
              "APP_FEE_REVENUE": 3,
              "AUTOMATIC_SAVINGS": 4,
              "AUTOMATIC_SAVINGS_REVERSED": 5,
              "CHARGE": 6,
              "DEPOSIT_FEE": 7,
              "DEPOSIT_FEE_REVERSED": 73,
              "DISPUTE": 8,
              "ESCHEATMENT": 9,
              "FEE": 10,
              "FREE_PROCESSING": 11,
              "HOLD_ADJUSTMENT": 12,
              "INITIAL_BALANCE_CHANGE": 13,
              "MONEY_TRANSFER": 14,
              "MONEY_TRANSFER_REVERSAL": 15,
              "OPEN_DISPUTE": 16,
              "OTHER": 17,
              "OTHER_ADJUSTMENT": 18,
              "PAID_SERVICE_FEE": 19,
              "PAID_SERVICE_FEE_REFUND": 20,
              "REDEMPTION_CODE": 21,
              "REFUND": 22,
              "RELEASE_ADJUSTMENT": 23,
              "RESERVE_HOLD": 24,
              "RESERVE_RELEASE": 25,
              "RETURNED_PAYOUT": 26,
              "SQUARE_CAPITAL_PAYMENT": 27,
              "SQUARE_CAPITAL_REVERSED_PAYMENT": 28,
              "SUBSCRIPTION_FEE": 29,
              "SUBSCRIPTION_FEE_PAID_REFUND": 30,
              "SUBSCRIPTION_FEE_REFUND": 31,
              "TAX_ON_FEE": 32,
              "THIRD_PARTY_FEE": 33,
              "THIRD_PARTY_FEE_REFUND": 34,
              "PAYOUT": 35,
              "AUTOMATIC_BITCOIN_CONVERSIONS": 36,
              "AUTOMATIC_BITCOIN_CONVERSIONS_REVERSED": 37,
              "CREDIT_CARD_REPAYMENT": 38,
              "CREDIT_CARD_REPAYMENT_REVERSED": 39,
              "SQUARE_CARD_PAYOUT": 40,
              "RETURNED_SQUARE_CARD_PAYOUT": 41,
              "MANUAL_PAYOUT": 42,
              "RETURNED_MANUAL_PAYOUT": 43,
              "LOCAL_OFFERS_CASHBACK": 44,
              "LOCAL_OFFERS_FEE": 46,
              "PERCENTAGE_PROCESSING_ENROLLMENT": 50,
              "PERCENTAGE_PROCESSING_DEACTIVATION": 51,
              "PERCENTAGE_PROCESSING_REPAYMENT": 52,
              "PERCENTAGE_PROCESSING_REPAYMENT_REVERSED": 53,
              "PROCESSING_FEE": 54,
              "PROCESSING_FEE_REFUND": 55,
              "UNDO_PROCESSING_FEE_REFUND": 56,
              "GIFT_CARD_LOAD_FEE": 57,
              "GIFT_CARD_LOAD_FEE_REFUND": 58,
              "UNDO_GIFT_CARD_LOAD_FEE_REFUND": 59,
              "BALANCE_FOLDERS_TRANSFER": 60,
              "CASH_FOR_BUSINESS_FEE_REFUND": 61,
              "CASH_FOR_BUSINESS_DISPUTE_OFFSET": 62,
              "CASH_FOR_BUSINESS_DISPUTE_OFFSET_REVERSED": 63,
              "CASH_FOR_BUSINESS_TRANSFER": 76,
              "CASH_FOR_BUSINESS_TRANSFER_REVERSED": 77,
              "CASH_FOR_BUSINESS_FEE_REFUND_REVERSED": 78,
              "BALANCE_FOLDERS_TRANSFER_REVERSED": 70,
              "GIFT_CARD_POOL_TRANSFER": 71,
              "GIFT_CARD_POOL_TRANSFER_REVERSED": 72,
              "SQUARE_PAYROLL_TRANSFER": 74,
              "SQUARE_PAYROLL_TRANSFER_REVERSED": 75,
              "CHECK_ISSUED": 79,
              "ACCRUED_PROCESSING_FEES": 80,
              "DELIVERY_REIMBURSEMENT": 81,
              "AUTOMATIC_BITCOIN_BUY": 82,
              "ONCHAIN_BITCOIN_WITHDRAWAL": 83,
              "LINE_OF_CREDIT_REPAYMENT": 84,
              "LINE_OF_CREDIT_REPAYMENT_REVERSED": 85,
              "LIGHTNING_PAYMENT": 86,
              "MARKET_BITCOIN_BUY": 87,
              "MARKET_BITCOIN_SELL": 88,
              "BLOCK_PROMOTION": 89,
              "EMPLOYEE_TIP_PAYMENT": 90,
              "EMPLOYEE_TIP_PAYMENT_REFUND": 91,
              "ONCHAIN_BITCOIN_DEPOSIT": 92,
              "ONCHAIN_BITCOIN_DEPOSIT_REVERSAL": 93
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentbalances?.nested?.ActivityType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActivityType @ squareup/paymentbalances/common.proto at 18:1
 */
export const ActivityType = $root.lookupEnum('squareup.paymentbalances.ActivityType').values;